export default __webpack_public_path__ + "static/media/ic_notifications_b.bd6bca59.svg";